module.exports = __webpack_public_path__ + "static/DattiloDJRBannerVariable-VF-ac1c221c80839a97f0921a8b4ff1a93a.woff2";